<template>
  <SearchForm ref="searchFormRef" :formModel="searchController.formModel" @search="tableController.search" :searchLoading="tableController.loading">
    <template #form>
      <el-form-item prop="templateCode">
        <el-input placeholder="科普编码" v-model="searchController.formModel.templateCode" clearable></el-input>
      </el-form-item>
      <el-form-item prop="templateDataName">
        <el-input placeholder="科普名称" v-model="searchController.formModel.templateDataName" clearable></el-input>
      </el-form-item>
    </template>
    <template #controll>
      <el-button type="primary" @click="clickAdd">新建</el-button>
    </template>
  </SearchForm>
  <ProTable
    :columns="tableController.columns"
    :tableData="tableController.tableData"
    :loading="tableController.loading"
    :total="tableController.total"
    :pageState="tableController.pageState"
    @pageChange="tableController.onPageChange"
  />

  <!-- 模态 -->
  <AddModal ref="addModalRef" @successAdd="tableController.search" @successEdit="tableController.refresh" />
</template>

<script>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import SearchForm from '@/components/SearchForm'
import ProTable from '@/components/ProTable'
import AddModal from './AddModal.vue'
import FetchSelect from '@/components/FetchSelect'
import CustomLink from '@/components/customStyle/CustomLink'
import useSearchFormCtrller from '@/hooks/useSearchFormCtrller'
import useTableController from '@/hooks/useTableController'
import { actionConfirm } from '@/utils/confirm'
import request from '@/utils/request'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const router = useRouter()
    const addModalRef = ref(null)
    // searchForm
    const searchController = useSearchFormCtrller({
      form: {
        templateCode: '',
        templateDataName: '',
      },
    })
    // table
    const columns = [
      { label: '科普名称', prop: 'templateDataName' },
      { label: '科普编码 ', prop: 'templateCode' },
      {
        label: '是否默认 ',
        prop: 'ifDefault',
        render: (v) => {
          return v == '1' ? '默认' : ''
        },
      },
      {
        label: '操作',
        prop: 'actions',
        width: 100,
        render: (_, record) => {
          return (
            <div>
              <CustomLink
                onClick={() => {
                  clickEdit(record)
                }}
              >
                编辑
              </CustomLink>
              <CustomLink
                onClick={() => {
                  router.push(`/web/system/uitemplatedata/uitemplatedatamgr/edit?templateCode=${record.templateCode}`)
                }}
              >
                编辑页面
              </CustomLink>
              <CustomLink onClick={() => handleDelete(record)}>删除</CustomLink>
            </div>
          )
        },
      },
    ]
    const tableController = useTableController({
      columns,
      ajax: ({ page, pageSize }) => {
        const postData = {
          page,
          rows: pageSize,
          ...searchController.formModel,
        }
        return request({
          url: '/web/system/uiTemplateData/getUiTemplateDataPaging',
          data: postData,
        }).then((data) => ({ list: data.data ?? [], totalNum: data.rowTop ?? 0 }))
      },
    })

    function clickAdd() {
      addModalRef.value?.open()
    }

    function clickEdit(record) {
      addModalRef.value?.open(record)
    }

    function handleDelete(record) {
      actionConfirm(`确认删除？`, () => {
        return request({
          url: '/web/system/uiTemplateData/updateUiTemplateDataDisabled',
          data: {
            templateCode: record.templateCode,
          },
        }).then(() => {
          tableController.refresh()
          ElMessage.success('操作成功')
        })
      })
    }

    return {
      searchController,
      tableController,
      //
      addModalRef,
      clickAdd,
    }
  },
  components: { SearchForm, ProTable, FetchSelect, AddModal },
}
</script>

<style></style>
